import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=57d6cbd7&scoped=true&"
import script from "./ClientTable.vue?vue&type=script&lang=js&"
export * from "./ClientTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=57d6cbd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d6cbd7",
  null
  
)

export default component.exports